import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const factoryComponentsPlugin = createPlugin({
  id: 'factory-components',
  routes: {
    root: rootRouteRef,
  },
});

export const EntityFactoryComponentsContent = factoryComponentsPlugin.provide(
  createRoutableExtension({
    name: 'EntityFactoryComponentsContent',
    component: () =>
      import('./components/FactoryComponentsContent').then(m => m.FactoryComponentsContent),
    mountPoint: rootRouteRef,
  }),
);
